module.exports = "/assets/goose.png";